<template>
  <div class="dashboardServicesCards__card">
    <div
      class="dashboardServicesCards__card"
      @click="$emit('select-case-request-type',requestType)"
    >
      <div class="dashboardServicesCards__card scrollAnimation scrollAnimation--active">
        <div class="dashboardServicesCards__cardWrapper">
          <div
            v-if="showTag"
            class="servicesTagsItemsCont"
          >
            <span class="dashboardServicesTags dashboardServicesTags__new">
              <i class="icon icon-category_justice pl-2" />
              جديد
            </span>
          </div>
          <h6 class="icon-category_justice dashboardServicesCards__serviceType icon">
            القضاء
          </h6>
          <p class="dashboardServicesCards__serviceDescription">
            {{ requestType.title }}

            <small class="d-block small text-muted dashboardServicesCards__Des">
              {{ requestType.shortExplanation }}
            </small>
          </p>
          <span class="dashboardServicesCards__moreLink"> تقديم الطلب </span>
          <div
            v-if="false"
            class="d-flex justify-content-flex-start text-center text-c-green"
          >
            <naj-button
              color="primary"
              :disabled="!isEnabled"
            >
            </naj-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RequestTypes, RequestTypesIds } from '@/helpers/enum';

export default {
  name: 'RequestTypeCard',
  components: {},
  props: {
    requestType: {
      type: Object,
      required: true,
    },
    showTag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      RequestTypesIds,
      RequestTypes,
    };
  },
  computed: {
    enabledRequestTypes() {
      return Object.keys(RequestTypesIds)
        .map(key => ({
          name: this.RequestTypesIds[key],
          id: key,
        }));
    },
    isEnabled() {
      return this.enabledRequestTypes.some(t => t.id == this.requestType.id);
    },
    caseObjectKey() {
      return this.$route.params.caseObjectKey;
    },
    isPega() {
      return this.$route.params.isPega == 'true';
    },
  },
  mounted() {
  },
  methods: {},
};

</script>

<style lang="scss" scoped>
.v-card {
  background-color: var(--app-light-secondary-color);
  box-shadow: 0px 11px 12px #00000029;
  border: 2px solid #f4f5f8;
  border-radius: 12px;

  .v-icon {
    font-size: 75px !important;
    // color: #158e8d !important;
  }
}
.header-text {
  font-weight: 700;
  font-size: 18px;
  // color: #158e8d !important;
}

    .text-c-green {
        color: var(--app-primary-color);
    }

.text-c-dark {
  color: var(--app-dark-primary-color);
}

.text-c-lite {
  color: #a6b8bb;
}

.text-info-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .naj-button {
  span {
    font-weight: normal !important;
    font-size: 13px !important;
  }
}

span.dashboardServicesTags {
  display: block;
  font-size: 10px;
  padding: 0px 12px;
  background-color: #f1f1f1;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  color: #fff;
  margin: 0px 3px;
}

span.dashboardServicesTags.dashboardServicesTags__new {
  background-color: #067377;
  color: #fff;
}

.servicesTagsItemsCont {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  padding: 0px 16px;
}

.dashboardServicesCards__Des {
  font-weight: normal;
  font-size: 12px;
  padding-top: 8px;
}
.dashboardServicesCards__serviceDescription {
  margin: 0 !important;
}

.dashboardServicesCards__card {
  &:hover {
    cursor: pointer;
  }
}

.dashboardServicesCards__card span.dashboardServicesCards__moreLink:after {
  width: 46px !important;
  text-align: center !important;
}
</style>
